import { isEligible } from '@wix/ambassador-premium-features-manager-v1-feature/http';
import type { ControllerFlowAPI } from '@wix/yoshi-flow-editor';

import { PREMIUM_UNIQUE_NAME } from '../utils/constants';

const getIsPremium = async (flowAPI: ControllerFlowAPI): Promise<boolean> => {
  const { data } = await flowAPI.errorHandler.withErrorHandler(
    () =>
      flowAPI.httpClient.request(
        isEligible({ uniqueName: PREMIUM_UNIQUE_NAME }),
      ),
    { errorCodesMap: {} },
  );

  return data.isEligible ?? false;
};

export const premiumService = {
  getIsPremium,
};
